export default {
  quicksight: '/',
  configurator: '/config',
}
